export function toggleRecurrenceFields() {
    const isChecked = document.getElementById("is_recurrence")?.checked;
    const fields = document.getElementById("recurrenceFields");
    if (!fields) return;

    fields.classList.toggle("hidden", !isChecked);
    toggleDaysOfWeek();
}

export function toggleDaysOfWeek() {
    const mode = document.getElementById("recurrence_mode")?.value;
    const container = document.getElementById("daysOfWeekContainer");
    const isRecurrence = document.getElementById("is_recurrence")?.checked;
    if (!container) return;

    if (isRecurrence && (mode === "weekly" || mode === "biweekly")) {
        container.classList.remove("hidden");
    } else {
        container.classList.add("hidden");
    }
}
